module.exports = __webpack_public_path__ + "images/ce757398c1fb265d30df41369a993d32-logo_white.png";